import { useMemo } from 'react'
import { useGetMeProfile } from '@cocoonspace/sdk-js/v2/domains/me-profile/me-profile'
import {
	Avatar,
	AvatarFallback,
	AvatarImage,
} from '@cocoonspace/ui/components/avatar'

import { useUserContext } from '~/providers/user-provider'
import { useAuth } from '../providers/auth-provider'
import { formatPersonName } from '~/utils/format-person-name'

export const UserAvatar = ({ size }: { size?: 'sm' | 'lg' | 'xl' }) => {
	const { user } = useAuth()
	const { userQuery } = useUserContext()
	const { data: meProfile } = useGetMeProfile({
		query: {
			enabled: !!user,
			retry: false,
		},
	})

	const initials = useMemo(() => {
		const name = formatPersonName(
			userQuery.data?.first_name,
			userQuery.data?.last_name,
		)

		if (!name) return ''

		return name
			.split(' ')
			.map((part) => part[0])
			.join('')
	}, [userQuery.data?.first_name, userQuery.data?.last_name])

	const photoUrl =
		meProfile?.avatarUrl ?? userQuery.data?.photo_url ?? user?.photoURL

	return (
		<Avatar size={size}>
			<AvatarImage src={photoUrl || undefined} />
			<AvatarFallback>{initials}</AvatarFallback>
		</Avatar>
	)
}
